import { Facebook, Linkedin, Youtube, Mail, Phone, MapPin } from "lucide-react";
import logo from "@/assets/logo-white.png";
import sslcommerz from "@/assets/sslcommerz.png";
import ScrollLink from "@/components/ScrollLink";

const Footer = () => {
  return (
    <footer className="gradient-dark text-primary-foreground">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              {/* Logo - Image only, easy to control width */}
              <img 
                src={logo} 
                alt="Web Host Buy BD - Best BDIX Hosting Provider in Bangladesh" 
                className="h-10 w-auto object-contain"
                width={180}
                height={40}
                style={{ maxWidth: '180px' }}
              />
            </div>
            <p className="text-primary-foreground/70 text-sm leading-relaxed text-justify">
              Web Host Buy BD is Bangladesh's leading & fastest BDIX hosting provider. We offer very reliable, high-performance BDIX hosting, VPS, and dedicated servers with affordable hosting prices in BD and 24/7 expert support.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/WebHostBuyBD" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors" aria-label="Follow Web Host Buy BD on Facebook">
                <Facebook className="w-5 h-5" aria-hidden="true" />
              </a>
              <a href="https://x.com/WebHostBuyBD" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors" aria-label="Follow Web Host Buy BD on X">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/WebHostBuyBD" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors" aria-label="Connect with Web Host Buy BD on LinkedIn">
                <Linkedin className="w-5 h-5" aria-hidden="true" />
              </a>
              <a href="https://www.youtube.com/@WebHostBuyBD" target="_blank" rel="noopener noreferrer" className="text-primary-foreground/70 hover:text-primary-foreground transition-colors" aria-label="Watch Web Host Buy BD on YouTube">
                <Youtube className="w-5 h-5" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick Links + Support + Contact with SSLCommerz below */}
          <div className="lg:col-span-3 space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Quick Links */}
              <nav aria-label="Quick links">
                <h3 className="font-semibold text-lg mb-4">BDIX Hosting Services</h3>
                <ul className="space-y-2">
                  <li>
                    <ScrollLink to="/bdix-web-hosting" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      BDIX Web Hosting
                    </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="/bdix-vps" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      BDIX VPS Hosting
                    </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="/bdix-dedicated-server" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      BDIX Dedicated Server
                    </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="/bdix-reseller-hosting" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      BDIX Reseller Hosting
                    </ScrollLink>
                  </li>
                </ul>
              </nav>

              {/* Support */}
              <nav aria-label="Support links">
                <h3 className="font-semibold text-lg mb-4">Support</h3>
                <ul className="space-y-2">
                  <li>
                    <ScrollLink to="/about-us" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      About
                    </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="/contact-us" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      Contact
                    </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="/privacy-policy" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                      Privacy Policy
                    </ScrollLink>
                  </li>
                  <li>
                    <ScrollLink to="/terms-conditions" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
              Terms &amp; Conditions
                    </ScrollLink>
                  </li>
                </ul>
              </nav>

              {/* Contact Info */}
              <div>
                <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
                <address className="not-italic">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <MapPin className="w-5 h-5 text-primary-foreground/70 flex-shrink-0 mt-0.5" aria-hidden="true" />
                      <span className="text-primary-foreground/70 text-sm">
                        10 Nur Vobon (2nd Floor)<br />
                        Nogor Vobon Road, Manikganj
                      </span>
                    </li>
                    <li className="flex items-center gap-3">
                      <Phone className="w-5 h-5 text-primary-foreground/70" aria-hidden="true" />
                      <a href="tel:+8809649660000" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                        +880 9649 660000
                      </a>
                    </li>
                    <li className="flex items-center gap-3">
                      <Mail className="w-5 h-5 text-primary-foreground/70" aria-hidden="true" />
                      <a href="mailto:hello@webhostbuybd.com" className="text-primary-foreground/70 hover:text-primary-foreground text-sm transition-colors">
                        hello@webhostbuybd.com
                      </a>
                    </li>
                  </ul>
                </address>
              </div>
            </div>

            {/* SSLCommerz Payment Methods */}
            <div className="pt-0">
              <img 
                src={sslcommerz} 
                alt="SSLCommerz Payment Methods - Pay with VISA, Mastercard, bKash, Nagad, and more" 
                className="w-full h-auto object-contain"
                width={960}
                height={120}
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-primary-foreground/60 text-sm text-center md:text-left">
            <span>© {new Date().getFullYear()} Web Host Buy BD.</span>
            <br className="md:hidden" />
            <span className="md:ml-1">All rights reserved.</span>
          </p>
          <nav className="flex gap-6" aria-label="Legal links">
            <ScrollLink to="/privacy-policy" className="text-primary-foreground/60 hover:text-primary-foreground text-sm transition-colors">
              Privacy Policy
            </ScrollLink>
            <ScrollLink to="/terms-conditions" className="text-primary-foreground/60 hover:text-primary-foreground text-sm transition-colors">
              Terms &amp; Conditions
            </ScrollLink>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;